export default (text: string, maxChars: number): string => {
  if (maxChars <= 0) {
    return ''
  }

  return text.length > maxChars ? text.slice(0, maxChars) : text
}
